import React, { forwardRef } from "react";
import classNames from "classnames";
import "./InputUnit.scss";

/** Пропсы компонента {@link InputUnit}. */
export interface InputUnitProps extends React.HTMLAttributes<HTMLSpanElement> {
    /** Краткое обозначение единицы измерения. */
    children: React.ReactNode;
}

/**
 * Единообразно отображает единицу измерения после значения поля. \
 * Передаётся в `endDecorator` у `Input` (мапится в `endAdornment` `@omega/ui`).
 *
 * @example
 * ```tsx
 * <Input
 *   type="number"
 *   label="Количество"
 *   endDecorator={<InputUnit>кг</InputUnit>}
 * />
 * ```
 */
export const InputUnit = forwardRef<HTMLSpanElement, InputUnitProps>(function InputUnit(
    { className, children, ...props },
    ref,
) {
    return (
        <span ref={ref} className={classNames("shared_input_unit", className)} {...props}>
            {children}
        </span>
    );
});

InputUnit.displayName = "InputUnit";
